import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Box, SxProps, Tooltip, Typography, useTheme } from "@mui/material";

export interface MyLeaveBarItemViewProps {
  percent: number;
  color: string;
  value: string;
  label: string;
  boxCurve: SxProps;
  TooltipNode: ReactNode;
  onlyBar?: boolean;
}

export const MyLeaveBarItemView: React.FC<MyLeaveBarItemViewProps> = ({
  boxCurve,
  TooltipNode,
  color,
  label,
  percent,
  value,
  onlyBar,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Tooltip title={TooltipNode} placement="top">
      <Box width={`${percent}%`}>
        {!onlyBar && (
          <Box
            sx={{
              minWidth: "100%",
              width: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                display: "block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                paddingBottom: "4px",
                color: theme.palette.gray60.main,
              }}
            >
              {t(label)}
            </Typography>
          </Box>
        )}
        <Box
          bgcolor={color}
          id="my-leave-bar-item-value-container"
          data-testid="my-leave-bar-item-value-container"
          height="24px"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...boxCurve,
          }}
        >
          <Typography
            variant="caption"
            color="#fff"
            sx={{
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
};
